
export enum UploadStatus {
  /** 错误 */
  ERROR = -1,
  REMOVED=-2,
  /** 等待中 */
  PENDING = 0,
  /** 上传中 */
  UPLOADING = 1,
  /** 上传成功 */
  SUCCESS = 2,
}

/**
 * 上传文件
 */
export interface UploadFile{
  id?:number|null
  uploadStatus: UploadStatus
  description?:string|null
  uploadToken?: string|null
  url?: string
  file_uri?: string
  name?: string
  uploadKey?: string|null
  progress?:number
  request?:XMLHttpRequest
  data?:File
  size?:number
}
export interface VideoFile extends UploadFile{
  thumbnails?:string[]
  duration:number
  previewUrl?:string
}
